import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCursor = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.2608 12.4009C19.3774 11.2626 20.4358 10.6935 20.7035 10.0085C20.9359 9.41399 20.8705 8.74429 20.5276 8.20593C20.1325 7.58557 18.9841 7.23182 16.6873 6.52431L8.00615 3.8502C6.06822 3.25324 5.09926 2.95477 4.45849 3.19675C3.90071 3.40739 3.466 3.8559 3.27288 4.41999C3.05103 5.068 3.37964 6.02717 4.03684 7.94551L6.94796 16.4429C7.75635 18.8026 8.16055 19.9824 8.80522 20.3574C9.36431 20.6827 10.0462 20.7174 10.6354 20.4508C11.3149 20.1433 11.8371 19.0107 12.8813 16.7455L13.6528 15.0719C13.819 14.7114 13.9021 14.5311 14.0159 14.3736C14.1168 14.2339 14.2354 14.1078 14.3687 13.9985C14.5188 13.8753 14.6937 13.7813 15.0433 13.5933L17.2608 12.4009Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCursor;
